export const listTableStyle = theme => ({
  wrapperTable: {
    maxWidth: '100%',
    overflow: 'auto',
    position: 'relative',
    '& > div': {
      minWidth: '990px'
    },
    userSelect: 'none',
    '-webkitOverflowScrolling': 'touch',
    '--crud-table-height': 'calc(100vh - 270px)',
    '@media only screen and (max-width: 600px)': {
      '--crud-table-height': 'auto'
    }
  },
  wrapperTableWithHeader: {
    borderRadius: '0 0 4px 4px !important'
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    position: 'absolute',
    background: 'rgba(255,255,255,.7)',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 999
  },
  paginationWrapper: {
    display: 'flex',
    alignItems: 'center',
    borderTop: '1px solid rgb(224, 224, 224)',
    fontSize: '0.75rem'
  },
  capitalizeField: {
    textTransform: 'capitalize'
  },
  pagination: {
    flex: 1
  },
  page: {
    color: 'rgba(0, 0, 0, 0.54)',
    paddingLeft: '24px',
    fontSize: '0.75rem'
  }
})

export default listTableStyle



// WEBPACK FOOTER //
// ./src/styles/listTable.js